import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from '@emotion/react';
import adnocTheme from './Theme';

import './index.css';
import './assets/fonts/fonts.css';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <ThemeProvider theme={adnocTheme}>
    <App />
  </ThemeProvider>
);